import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import useOrganizationGroups from '../../../../../hooks/api/useOrganizationGroups';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import BulkAddClientProfilesGroups from '../../../../shared/BulkAddClientProfilesGroups';
import { useOrganizationClientRecords } from '../../../../../hooks/api/useOrganizationClientRecords';

const intl = getIntl('bulk-add-client-profiles-groups-screen', {
    cancel: 'Cancel',
    save: 'Save',
});

export type BulkAddClientProfilesGroupsScreenOwnProps = {};

export type BulkAddClientProfilesGroupsScreenProps = BulkAddClientProfilesGroupsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'bulk-add-client-profiles-groups'>;
};

const BulkAddClientProfilesGroupsScreen: React.FC<BulkAddClientProfilesGroupsScreenProps> = (props) => {
    const goBack = useGoBack();
    const { bulkAddClientRecordsToGroups, isBulkAddingClientRecordsToGroups } = useOrganizationClientRecords({
        onBulkAddClientRecordsToGroupsSuccess: goBack,
    });
    const { isLoadingGroups, groups } = useOrganizationGroups({});
    const [selectedGroupIds, setSelectedGroupIds] = React.useState<string[]>([]);

    return (
        <AnimateLoadedContent isLoading={isBulkAddingClientRecordsToGroups || isLoadingGroups}>
            {() => (
                <ActionButtonLayout
                    actions={[
                        {
                            title: intl('cancel'),
                            variant: 'secondary',
                            icon: 'XCircle',
                            onPress: goBack,
                            testID: 'cancel-bulk-add-client-profiles-groups',
                        },
                        {
                            title: intl('save'),
                            variant: 'primary',
                            onPress: () => {
                                bulkAddClientRecordsToGroups({
                                    organizationGroupIds: selectedGroupIds,
                                    organizationClientRecordIds: props.route.params.clientRecordIds,
                                });
                            },
                            icon: 'CheckCircle',
                            isDisabled: selectedGroupIds.length === 0,
                            testID: 'save-bulk-add-client-profiles-groups',
                        },
                    ]}
                    scrollable
                >
                    <MainContentContainer>
                        <BulkAddClientProfilesGroups
                            organizationGroups={groups}
                            selectedGroupIds={selectedGroupIds}
                            onSelectedGroupIdsChange={setSelectedGroupIds}
                            clientRecordIds={props.route.params.clientRecordIds}
                        />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(BulkAddClientProfilesGroupsScreen);
